import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const ChartIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props}>
    <title>Reports</title>
    <path d="M23,34H19V8h4Zm6-22H25V34h4ZM41,22H37V34h4Zm-6-2H31V34h4ZM11,28H7v6h4Zm6-4H13V34h4ZM41,36H7v4H41Z" />
  </IconBase>
);
